import { combineReducers } from 'redux';

import cart from './CartReducer';
import constants from './ConstantReducer';
import currency from './CurrencyRateReducer';
import download from './DownloadReducer';
import layout from './LayoutReducer';
import locale from './LocaleReducer';
import notification from './NotificationReducer';
import user from './UserReducer';
import zopim from './ZopimReducer';
import report from './AsyncTaskReportReducer';

export default combineReducers({
  user,
  locale,
  constants,
  layout,
  cart,
  download,
  notification,
  currency,
  report,
  zopim,
});
